import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Clase base para componentes que necesitan gestión automática de suscripciones.
 *
 * USO:
 * 1. Extender esta clase en tu componente
 * 2. Usar destroy$ con takeUntil en todas las suscripciones
 *
 * @example
 * export class MiComponente extends UnsubscribeOnDestroy implements OnInit {
 *   ngOnInit() {
 *     this.miServicio.getData()
 *       .pipe(takeUntil(this.destroy$))
 *       .subscribe(data => console.log(data));
 *   }
 * }
 */
@Directive()
export abstract class UnsubscribeOnDestroy implements OnDestroy {
  /**
   * Subject que emite cuando el componente se destruye.
   * Usar con takeUntil() para cancelar suscripciones automáticamente.
   */
  protected destroy$ = new Subject<void>();

  /**
   * Hook del ciclo de vida que se ejecuta al destruir el componente.
   * Emite un valor en destroy$ y completa el Subject.
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
